export const PRIMARY = "#F89E19";
export const BLACK = "#000000";
export const WHITE = "#FFFFFF";
export const RED = "#FF3B30";
export const GRAY_SCALE = "#DFE0EB";
export const BACK_GROUND = "#F6F7FB";
export const BLUE = "#3F91FF";
export const GREEN = "#00A400";
export const YELLOW = "#F89E19";
export const GREY = "#747475";

export const COLOR = {
  PRIMARY: "#F89E19",
  BLACK: "#000000",
  WHITE: "#FFFFFF",
  RED: "#FF3B30",
  GRAY_SCALE: "#DFE0EB",
  BACKGROUND: "#F6F7FB",
  BLUE: "#3F91FF",
  GREEN: "#00A400",
  YELLOW: "#F89E19",
  GREY: "#747475",
  DISABLE: "#a3a3a3",
};
